import {TicketController} from "./ticket.ctrl";
import {TicketUtils} from "./ticket.utils";
import {PlaceOrderService} from "./services/PlaceOrderService";
import {TmcVideoModal} from "./services/tmc-video/TmcVideoModal";
import {TradingLevelWarningDialog} from "./services/trading-level-warning/TradingLevelWarningDialog";
import {OrderVettingService} from "./services/OrderVettingService";
import {TradeService} from "./services/TradeService";

import Common from "./common";
import EquityTicket from "./equity-ticket";
import MultiAccountEquityTicket from "./multi-equity-ticket";
import SingleAccountOrderDialog from "./multi-equity-ticket/single-account-order-dialog";
import PlaceMultiAccountEquityOrderWizard from "./place-multi-equity-order-wizard";
import EquityOrderWizard from "./place-equity-order-wizard";
import OrderWizard from "./place-order-wizard";
import {OptionTicketDialogService} from "./services/dialog/OptionTicketDialogService";
import {TmcWarningDialog} from "./services/tmc-warning/TmcWarningDialog";
import {tmcWarning, TmcWarning} from "./services/tmc-warning/component/TmcWarningDialogComponent";
import {DuplicateOrderService} from "./services/DuplicateOrderService";
import {OrderAdviceService} from "./services/OrderAdviceService";
import {TradingLevelService} from "./services/TradingLevelService";
import PlaceChildOrderWizard from "./place-child-order-wizard";
import {MultiAccountTradeService} from "./services/MultiAccountTradeService";

const ModuleName = "tf.portfolio.ticket";
export default angular.module(ModuleName, [Common(ModuleName), EquityTicket(), MultiAccountEquityTicket(), SingleAccountOrderDialog(), EquityOrderWizard, PlaceMultiAccountEquityOrderWizard, OrderWizard, PlaceChildOrderWizard])
                      .controller("ticketCtrl", TicketController)
                      .service("ticketUtil", TicketUtils)
                      .service(PlaceOrderService.id, PlaceOrderService)
                      .service(TmcVideoModal.id, TmcVideoModal)
                      .service(TradingLevelWarningDialog.id, TradingLevelWarningDialog)
                      .service(TradingLevelService.id, TradingLevelService)
                      .service(OrderVettingService.id, OrderVettingService)
                      .service(DuplicateOrderService.id, DuplicateOrderService)
                      .service(TradeService.id, TradeService)
                      .service(MultiAccountTradeService.id, MultiAccountTradeService)
                      .service(OptionTicketDialogService.id, OptionTicketDialogService)
                      .service(TmcWarningDialog.id, TmcWarningDialog)
                      .service(OrderAdviceService.id, OrderAdviceService)
                      .component(TmcWarning, tmcWarning())
                      .name;
